/** 컴포넌트 타입 — 앱에서 보여줄 UI 디자인 */
export type HomeComponentType = "banner" | "featured" | "category" | "shortcut" | "card" | "review" | "ranking" | "instructor" | "tour" | "gallery" | "community";

/** 컴포넌트 레이아웃 — display CSS 담당 */
export type HomeComponentLayout = "grid" | "carousel" | "slide" | "masonry" | "calendar" | "list";

export const COMPONENT_TYPE_OPTIONS: {
  value: HomeComponentType;
  label: string;
  description: string;
  allowedLayouts: HomeComponentLayout[];
}[] = [
  {
    value: "banner",
    label: "배너",
    description: "이미지 중심 프로모션 (2:1비율 권장)",
    allowedLayouts: ["carousel", "slide"],
  },
  {
    value: "category",
    label: "버튼",
    description: "1행 2열 구조의 아이콘+이름  버튼",
    allowedLayouts: ["grid"],
  },
  {
    value: "shortcut",
    label: "퀵메뉴",
    description: "1행 5열 구조의 바로가기 버튼",
    allowedLayouts: ["grid"],
  },
  {
    value: "card",
    label: "카드",
    description: "상품, 기획전, 수강권 프로모션 컴포넌트",
    allowedLayouts: ["grid", "carousel", "slide"],
  },
  {
    value: "review",
    label: "후기/리뷰",
    description: "사용자 후기 컴포넌트",
    allowedLayouts: ["carousel", "slide"],
  },
  {
    value: "ranking",
    label: "랭킹",
    description: "순위 표시 컴포넌트",
    allowedLayouts: ["grid", "carousel"],
  },
  {
    value: "instructor",
    label: "프로필",
    description: "강사 프로필·전문 분야 카드",
    allowedLayouts: ["carousel", "slide"],
  },
  {
    value: "tour",
    label: "투어",
    description: "출발 회차·마감임박 표시",
    allowedLayouts: ["carousel", "grid"],
  },
  {
    value: "gallery",
    label: "갤러리",
    description: "피드형 이미지 중심 컴포넌트",
    allowedLayouts: ["masonry", "grid"],
  },
  {
    value: "community",
    label: "인기게시글",
    description: "인기 게시글 리스트 컴포넌트",
    allowedLayouts: ["carousel"],
  },
];

export const LAYOUT_OPTIONS: {
  value: HomeComponentLayout;
  label: string;
  description: string;
}[] = [
  { value: "grid", label: "그리드", description: "격자형 배치" },
  { value: "carousel", label: "카로셀", description: "좌우 스크롤" },
  { value: "slide", label: "슬라이드", description: "전체 화면 슬라이드" },
  { value: "masonry", label: "매소너리", description: "SNS 피드형 벽돌 배치" },
  { value: "calendar", label: "캘린더", description: "월간 캘린더 표시" },
  { value: "list", label: "리스트", description: "정보 전달형 리스트" },
];

export type ItemFormFieldType = "text" | "number" | "select" | "datetime" | "tags" | "idSelect" | "month" | "image";

export type IdSelectSource = "instructors" | "tours";

export interface ItemFormField {
  /** 서버 응답(HomeScreenSettingItem) 필드명과 동일하게 snake_case 로 작성 */
  key: string;
  label: string;
  type: ItemFormFieldType;
  placeholder?: string;
  required?: boolean;
  options?: { value: string; label: string }[];
  source?: IdSelectSource;
  autofillKeys?: string[];
  /** type === "image" 일 때 업로드 버튼 하단에 노출할 안내 문구 */
  hint?: string;
}
